import React from 'react'
import AppHeader from "../../components/header";
import {Route,Switch,Redirect} from "react-router-dom";
import ProjectsList from "./list";
import CreateProposal from "./create";
import ProjectDetailPage from "./detail";

const ConsolePage = (
    {
        ...props
    }
)=>{

    var path = props.location?.pathname

    return(
        <div className={path=='/projects' && 'background dark-blue-bg'}>
            <AppHeader
                transparent={path=='/projects'}
            mini
            />

            <Switch>
                <Route path={'/projects/create'} component={CreateProposal} />
                <Route path={'/projects/:id'} component={ProjectDetailPage} />
                <Route exact path={'/projects'} component={ProjectsList}/>
                <Redirect to={'/projects'} />
            </Switch>
            </div>
    )

}

export default ConsolePage